import React, { useEffect, useRef } from "react";
import "./App.css";
import "./index.css";
import "./components/common_components/common_css/table_css/table_css.css";
import "./components/common_components/common_css/custom_modal_css/custom_modal_css.css";
import "./components/common_components/common_css/form_css/form_css.css";
import "./components/common_components/common_css/action_btn_css/action_btn_css.css";
import "./components/common_components/common_css/swiper_css/swiper_css.css";
import "./components/common_components/common_css/btn_css/btn_css.css";
import { Route, Routes, useLocation } from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Welcome from "./components/welcome/Welcome";
import ScrollToTop from "./components/ScrollTotop/ScrollTotop";
import Home from "./components/home/Home";
import Study_abroad from "./components/study_abroad/Study_abroad";
import France from "./components/internship/france/France";
import About_us from "./components/about_us/About_us";
import Contact_Us from "./components/contact-us/Contact_Us";
import Terms_Conditions from "./components/terms-conditions/Terms_Conditions";
import Privacy_Policy from "./components/privacy-policy/Privacy_Policy";
import Blog from "./components/blog/Blog";
import Blog_inner from "./components/blog/blog_inner/Blog_inner";


function App() {
  const location = useLocation();
  const prevPath = useRef(location.pathname);

  // Routes where header must be hidden
  const hideHeaderRoutes = ["/welcome", "/user-login"];

  // Hide header for these routes + ALL /portal routes
  const hideHeader =
    hideHeaderRoutes.includes(location.pathname) ||
    location.pathname.startsWith("/portal");

  useEffect(() => {
    if (prevPath.current !== location.pathname) {
      prevPath.current = location.pathname;

      // 👉 reload page
      window.location.reload();
    }
  }, [location.pathname]);

  return (
    <>
      <ScrollToTop />

      {/* Hide Header Logic */}
      {!hideHeader && <Header />}

      <Routes>
        <Route path="/welcome" element={<Welcome />} />
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/study-abroad" element={<Study_abroad />} />
        <Route path="/internship/:id" element={<France />} />
        <Route path="/about-us" element={<About_us />} />
        <Route path="/contact-us" element={<Contact_Us />} />
        <Route path="/terms-conditions" element={<Terms_Conditions />} />
        <Route path="/privacy-policy" element={<Privacy_Policy />} />
        <Route path="/blogs" element={<Blog />} />
         <Route path="/blog-inner/:id" element={<Blog_inner />} />
      </Routes>

      <Footer />
    </>
  );
}

export default App;
